import React from 'react'
import IconBase from './IconBase'

interface PropsType {
  width?: number | string
  height?: number | string
  className?: string
}

const ExchangeIcon = (props: PropsType) => {
  const { width, height, className } = props
  return (
    <IconBase title="icon-exchange" width={width} height={height} className={className}>
      <path d="M549.658 84.021l-26.2 55.007C476.74 54.049 388.551 0 289.612 0 171.35 0 68.347 77.295 33.313 192.334l47.827 14.575C109.717 113.049 193.506 50 289.612 50c79.94 0 151.284 43.572 189.5 112.2l-59.28-16.362-13.306 48.193 129.15 35.645L594.8 105.53zM488.306 345.8C465.173 436.6 384.937 500 293.176 500 218 500 150.855 457.731 116.182 392.7l48.942 18.29 17.5-46.851-121.357-45.328L0 437.817l44.458 22.876 25.229-49.006C112.13 495.321 197.4 550 293.176 550c114.636 0 214.795-78.894 243.591-191.846z" />
    </IconBase>
  )
}

export default ExchangeIcon
